import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trainStopSignalImages: [],
  loadingTrainStopSignalImages: false,
  stations: [],
  loadingStations: false,
};

const trainStopSignalImageSlice = createSlice({
  name: "trainStopSignalImages",
  initialState,
  reducers: {
    loadingTrainStopSignalImages(state) {
      state.loadingTrainStopSignalImages = true;
    },
    loadingTrainStopSignalImagesDone(state) {
      state.loadingTrainStopSignalImages = false;
    },
    setTrainStopSignalImages(state, action) {
      state.trainStopSignalImages = action.payload;
    },
    loadingStations(state) {
      state.loadingStations = true;
    },
    loadingStationsDone(state) {
      state.loadingStations = false;
    },
    setStations(state, action) {
      state.stations = action.payload;
    },
  },
});

export const {
  loadingTrainStopSignalImages,
  loadingTrainStopSignalImagesDone,
  setTrainStopSignalImages,
  loadingStations,
  loadingStationsDone,
  setStations,
} = trainStopSignalImageSlice.actions;

export default trainStopSignalImageSlice.reducer;
